import useMdBreakpoint from "./useMdBreakpoint";

const HEX_WIDTH_RAW = 28;
const HEX_HEIGHT_RAW = 30;

const calculateSizes = (isDesktop: boolean) => {
  const scale = isDesktop ? 1.5 : 1.0;
  const HEX_WIDTH_BTN_BG = HEX_WIDTH_RAW * scale;
  const HEX_HEIGHT_BTN_BG = HEX_HEIGHT_RAW * scale;
  const HEX_WIDTH_INNER_BY_SCREEN = isDesktop ? 150 : 100;
  const HEX_HEIGHT_INNER_BY_SCREEN = isDesktop ? 163 : 109;

  return {
    HEX_WIDTH_INNER: HEX_WIDTH_INNER_BY_SCREEN,
    HEX_HEIGHT_INNER: HEX_HEIGHT_INNER_BY_SCREEN,
    HEX_WIDTH_OUTER: HEX_WIDTH_INNER_BY_SCREEN + 6,
    HEX_HEIGHT_OUTER: HEX_HEIGHT_INNER_BY_SCREEN + 6,
    HEX_WIDTH_BTN_BG,
    HEX_HEIGHT_BTN_BG,
  };
};

export const useHexagonSize = () => {
  const isMd = useMdBreakpoint();
  return calculateSizes(isMd);
};
